// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__4p1za","wrapper":"CaptureVisa_style_wrapper__9UHwJ","rotate":"CaptureVisa_style_rotate__wOK8r"};